import { LicenseInfo } from './types';

export const getLicensesData = async (): Promise<LicenseInfo[]> => {
  try {
    const response = await fetch('/licenses.json');

    if (!response.ok) {
      throw new Error('Failed to load licenses data with status code ' + response.status);
    }

    const data = await response.json();

    return Object.keys(data)
      .map(key => {
        const { licenses } = data[key];
        let cleanName = key.split('@')[0] === '' ? key.split('@')[1] : key.split('@')[0];
        cleanName = cleanName.startsWith('@') ? cleanName.slice(1) : cleanName;

        return {
          name: cleanName,
          licenseType: licenses,
        };
      })
      .filter(license => license.licenseType.includes('Apache'));
  } catch (error) {
    throw error;
  }
};
